import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setColor, setWebsiteType } from "../store/onLoadData/onLoadDataSlice";
import { eWebsiteColors, eWebsiteTypes } from "../utils";

export const useSetWebsiteConfig = () => {
  const dispatch = useDispatch();

    useEffect(() => {

      if(import.meta.env.VITE_WEBSITE_NAME === "Kuick"){
        dispatch(setWebsiteType(eWebsiteTypes.KUICK));
        dispatch(setColor(eWebsiteColors.KUICK));
        return;
      }

      if(import.meta.env.VITE_WEBSITE_NAME === "DineOrder"){
        dispatch(setWebsiteType(eWebsiteTypes.DINEORDER));
        dispatch(setColor(eWebsiteColors.DINEORDER));
        return;
      }

      if (window.location.hostname.toLocaleLowerCase().includes("dineorder")) {
        dispatch(setWebsiteType(eWebsiteTypes.DINEORDER));
        dispatch(setColor(eWebsiteColors.DINEORDER));
      } else {
        dispatch(setWebsiteType(eWebsiteTypes.KUICK));
        dispatch(setColor(eWebsiteColors.KUICK));
      }
    }, []);
};